import { useEffect, useRef } from "react";
import Image from "next/image";
import css from "./icon.module.scss";

export function Icon({
  className = "",
  src = "https://assets.aqar.fm/icons/",
  height = 30,
  name,
  width = 30,
  priority = false,
  alt = "",
  style = {},
  asSVG = false,
  onError = undefined,
  ...props
}) {
  const ref = useRef(null);
  useEffect(() => {
    if (!asSVG) return;
    const toLoad = `${src + (name || "")}.svg`;
    if (!src || !name) return;
    fetch(toLoad)
      .then((res) => res.text())
      .then((svg) => {
        if (!ref.current) return;
        ref.current.innerHTML = svg;
      })
      .then(() => {
        ref.current.firstElementChild.setAttribute("width", `${width}`);
        ref.current.firstElementChild.setAttribute("height", `${height}`);
      })
      .catch(console.log);
  }, [src, name, asSVG]);
  return (
    <span {...props} ref={ref} className={`${css.icon} ${className || ""}`}>
      {asSVG ? (
        <span
          style={{
            width,
            height,
            display: "inline-block",
          }}
        />
      ) : (
        <Image
          unoptimized
          alt={alt || ""}
          width={width}
          height={height}
          src={`${src}${name}.svg`}
          priority={priority}
          style={{ width, height, ...(style || {}) }}
          onError={onError}
        />
      )}
    </span>
  );
}

export default Icon;
